import { AlertCircle } from 'lucide-react';

export default function BetweenSizesAlert({ warning }) {
  if (!warning) return null;

  return (
    <div className="mt-4 flex gap-3 rounded-xl border border-amber-500/40 bg-amber-950/30 px-4 py-3 text-sm text-amber-100/90">
      <AlertCircle className="w-5 h-5 shrink-0 text-amber-400" />
      <p>
        {warning.message}{' '}
        <strong className="text-amber-200">
          {warning.smallerVal} / {warning.largerVal}
        </strong>
      </p>
    </div>
  );
}
